import React, { useContext, useEffect, useState } from 'react'
import { Input, Button, IconButton } from '@material-tailwind/react'
import { NewContext } from '../../Context/NewContext';
import { get_encoding_string } from '../../Controller/actions';
import { toast } from 'react-toastify';
import { TiClipboard } from 'react-icons/ti';

const BinaryEncoding = ({ title }) => {
  const { permissions, tokenType, setFormData, formData, currentPageData, setCurrentPageData } = useContext(NewContext);
  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = await get_encoding_string(formData)
    setCurrentPageData(data)
  }
  const copyText = async (data) => {
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(data);
        toast.success("Data Copied Successfully");
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = data;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        toast.success("Data Copied Successfully");
      }
    } catch (error) {
      toast.error("Error copying text to clipboard");
    }
  };

  const [pagePermissions, setPagePermissions] = useState({
    CU: true,
    R: true,
    D: true
  });
  useEffect(() => {
    if (tokenType === 'ldap') {
      const update = permissions?.subPermissions?.find((route) => route.name === 'Binary_Encoding')
      setPagePermissions({
        ...pagePermissions, CU: update?.CU, R: update?.R, D: update?.D
      })
    }
  }, [tokenType, permissions])

  useEffect(() => {
    document.title = title;
  }, [title])
  return (
    <div className="">
      <div className="">
        <h2 className={`font-medium text-[24px] text-[#1E1627] leading-none`}>BinaryEncoding Form</h2>
      </div>
      <div className='m-10 flex flex-row add-edit-form'>
        <div className='flex-row mt-4'>
          <label htmlFor="encodeValue" className="block text-sm font-medium leading-6 text-gray-900 mr-2 ">Input:</label>
          <Input id='encodeValue' name='encodeValue' onChange={onChange} placeholder="encodeValue" autoComplete='off' className='mr-4 ' type='string' />
        </div>
        <Button
          onClick={handleSubmit}
          className="lg:ml-3 lg:px-2 2xl:px-3 flex items-center bg-[#0047FF] capitalize text-sm leading-none font-medium whitespace-nowrap shadow-none hover:shadow-none mt-10"
          type='button'
        >
          <span>Convert Encoding</span>
        </Button>
      </div>
      <div className="flex flex-row ml-10 items-center gap-2">
        {currentPageData?.data && (
          <>
            <div className='w-64 break-words'>
              {currentPageData?.data.replace(/\s/g, '')}
            </div>
            <IconButton className='bg-[#EAEDF3] text-[#000000] text-[21px] shadow-none hover:shadow-none' onClick={() => { copyText(currentPageData?.data) }}>
              <TiClipboard />
            </IconButton>
          </>
        )}
      </div>
    </div>


  );
};

BinaryEncoding.defaultProps = {
  title: "Message | Binary Encoding"
};

export default BinaryEncoding
